const safeId=s=>String(s||'').replace(/[^a-zA-Z0-9_-]/g,'');
const loaded=new Set();
export function configureTracking(assessment) {
 if(!assessment)return;
 const {metaPixelId,gaMeasurementId,clarityId}=assessment.tracking||{};
 if(metaPixelId&&!loaded.has('meta:'+metaPixelId)){
   loaded.add('meta:'+metaPixelId);
   window.fbq=window.fbq||function(){(window.fbq.q=window.fbq.q||[]).push(arguments);};
   const s=document.createElement('script');s.async=true;s.src='https://connect.facebook.net/en_US/fbevents.js';document.head.appendChild(s);
   window.fbq('init',safeId(metaPixelId));
 }
 if(gaMeasurementId&&!loaded.has('ga:'+gaMeasurementId)){
   loaded.add('ga:'+gaMeasurementId);
   const s=document.createElement('script');s.async=true;s.src='https://www.googletagmanager.com/gtag/js?id='+encodeURIComponent(safeId(gaMeasurementId));document.head.appendChild(s);
   window.dataLayer=window.dataLayer||[];window.gtag=function(){window.dataLayer.push(arguments);};
   window.gtag('js',new Date());window.gtag('config',gaMeasurementId);
 }
 if(clarityId&&!loaded.has('clarity:'+clarityId)){
   loaded.add('clarity:'+clarityId);
   window.clarity=window.clarity||function(){(window.clarity.q=window.clarity.q||[]).push(arguments);};
   const s=document.createElement('script');s.async=true;s.src='https://www.clarity.ms/tag/'+encodeURIComponent(safeId(clarityId));document.head.appendChild(s);
 }
}
export function trackAssessment(id,event,extra={}) {
 const payload={assessment_id:id,...extra};
 window.dispatchEvent(new CustomEvent('bpa:assessment-event',{detail:{event,...payload}}));
 if(typeof window.fbq==='function')window.fbq('trackCustom','BPA_'+event,payload);
 if(typeof window.gtag==='function')window.gtag('event',event,payload);
}